import { render, staticRenderFns } from "./ShipmentListItems.vue?vue&type=template&id=2fb2702d&"
import script from "./ShipmentListItems.vue?vue&type=script&lang=ts&"
export * from "./ShipmentListItems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports